export const RELATIVE_RISK_LABELS = {
  tooConservative: 'Very conservative',
  conservative: 'Conservative',
  moderate: 'Recommended',
  aggressive: 'Aggressive',
  tooAggressive: 'Very aggressive',
};
